import { render, staticRenderFns } from "./PreferenceBar.vue?vue&type=template&id=f5a9b8fc"
import script from "./PreferenceBar.vue?vue&type=script&lang=js"
export * from "./PreferenceBar.vue?vue&type=script&lang=js"
import style0 from "./PreferenceBar.vue?vue&type=style&index=0&id=f5a9b8fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports